<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="8">
          <div class="page-title">作業列表</div>
        </el-col>
        <el-col :span="18" style="text-align: right;">
          <el-button size="mini" type="info" @click.native="onAdd">新增作業</el-button>
        </el-col>
      </el-row>

      <div class="page-box">
        <div class="page-box-content">
          <div class="page-content-row">
            <div>
              <div class="search-text">作業編號</div>
              <el-input
                v-model="formLabelAlign.numberLike"
                placeholder="請輸入作業編號"
              ></el-input>
            </div>
            <div v-if="userInfoRoleRoleId ==siteAdminRoleId">
              <div class="search-text">分校</div>
              <el-select
                  v-model="formLabelAlign.branchSchoolsId" placeholder="全部"
              >
                <el-option
                    v-for="(item, index) in $store.getters.branchSchools"
                    :key="index"
                    :label="item.abbreviation"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">年級</div>
              <el-select v-model="formLabelAlign.gradeId" placeholder="全部">
                <el-option
                  v-for="(item, index) in grades"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">語言</div>
              <el-select v-model="formLabelAlign.lang" placeholder="全部">
                <el-option
                  v-for="item in languages"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <el-button size="mini" type="info" @click="onSearch" class="button-el-el">搜尋全部</el-button>
            </div>
            <div>
              <el-button size="mini" type="info" @click="onSearchMy" class="button-el-el">我創建的作業</el-button>
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="number"
            label="作業編號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
              prop="branchSchoolsAbbreviation"
              label="分校"
              align="center"
              sortable="custom"
          ></el-table-column>
          <el-table-column
              prop="createdName"
              label="創建人"
              align="center"
              sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="gradeId"
            label="年級"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
                <span>{{row.gradeName}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="lang"
            label="語言"
            align="center"
          >
          <template slot-scope="{row}">
                <span>{{row.lang | language}}</span>
          </template>
          </el-table-column>

          <el-table-column
            prop="startDate"
            label="開始日期"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
                <span>{{row.startDate | formatDate}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="endDate"
            label="結束日期"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
                <span>{{row.endDate | formatDate}}</span>
          </template>
          </el-table-column>
           <el-table-column
           prop="updatedAt"
            label="最後更新時間"
            align="center"
            sortable="custom"
            
          >
           <template slot-scope="{row}">
               <span>{{row.updatedAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="editor"
            label="最後更新帳號"
            align="center"
            
          >
           <template slot-scope="{row}">
               <span>{{row.editor}}</span>
           </template>
          </el-table-column>
          <el-table-column
              prop="progress"
              label="完成數/總數"
              align="center"
              sortable="custom"
          >
          </el-table-column>
          <el-table-column label="操作"  align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="medium" @click="onCopyButton(row.id)"
              >複製</el-button
              >
              <el-button type="text" size="medium" @click="onEditButton(row.id)"
                >編輯</el-button
              >
              <el-button v-if="userInfoRoleRoleId !=teacherRoleId && userInfoRoleRoleId !=editorRoleId" type="text" size="medium" @click="onDeleteButton(row.id)"
                >刪除</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(row.id)"
                >詳情</el-button
              >
              <el-button type="text" size="medium" @click="downloadPdf(row.number, row.id)"
                >匯出PDF</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getHomeworks"
    />
    <deleteDialog
      titleCh="您確定要刪除此作業嗎？"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="confirmFunction"
      @onCancelButton="onCancelButton"
    ></deleteDialog>

    <div class="mask" v-if="examination_switch">
      <examination ref="examination" @closeLoading="loading_switch = false"></examination>
    </div>

    <loadingDialog :center-dialog-visible="loading_switch" loading-text="正在匯出。。。">正在匯出。。。</loadingDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getHomeworks,deleteHomeworks } from "@/api/homeworks";
import deleteDialog from "@/components/deleteDialog";
import examination from "./components/examination.vue";
import loadingDialog from "@/components/loadingDialog/index";
import {getGrades} from '@/api/grade'
export default {
  components: { deleteDialog, Pagination, examination, loadingDialog },
  data() {
    return {
      loadingMsg: '正在匯出。。。',
      itemId:0,
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        numberLike: null,
        gradeId: null,
        branchSchoolsId:null,
        createdId:null,
        lang: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
      grades: [],

      examination_switch: false,
      loading_switch: false
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getHomeworks();
    this.getGrades();
  },
  methods: {
    downloadPdf(title, id) {
      this.examination_switch = true
      this.$nextTick(() => {
        this.loading_switch = true
        let examination = this.$refs.examination
        examination.init(title, id)
      })
    },
    onDeleteButton(id){
       this.itemId = id
       this.centerDialogVisible = true
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getHomeworks();
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if (key === "_page") {
          this.formLabelAlign[key] = 1;
        } else if (key === "_limit") {
          this.formLabelAlign[key] = 50;
        }
      })
      this.getHomeworks();
    },
    onSearch() {
      this.formLabelAlign.createdId = null;
      this.getHomeworks();
    },
    onSearchMy() {
      this.formLabelAlign.createdId = this.$store.getters.adminUserInfo.userId;
      this.getHomeworks();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
     this.deleteHomeworks()
    },
    onAdd(){
      let path = `/job/add`;
      this.resolveRouter(path)
    },
    onCopyButton(id) {
      let path = `/job/${id}/copy`;
      this.resolveRouter(path)
    },
    onEditButton(id) {
      let path = `/job/${id}/edit`;
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/job/${id}`;
      this.resolveRouter(path)
    },
    deleteHomeworks(){
      deleteHomeworks(this.itemId).then(()=>{
        this.getHomeworks()
      }).finally(()=>{
        this.centerDialogVisible = false;

      })
    },
    onAlterButton(id) {
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    getGrades(){
      getGrades().then((v) => {
        this.grades = v.data;
      });
    },
    getHomeworks() {
      let formLabelAlign = {
        numberLike: this.formLabelAlign.numberLike,
        gradeId: this.formLabelAlign.gradeId,
        createdId: this.formLabelAlign.createdId,
        branchSchoolsId: this.formLabelAlign.branchSchoolsId,
        lang: this.formLabelAlign.lang,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getHomeworks(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
  .mask {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: skyblue;
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
.page-box-content{
  width: 100%;
  overflow-x: auto;
}
.page-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(8, 150px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
</style>